import { useEffect, useState } from "react";
import { PaginationProps } from "./Pagination.types";

const usePresenter = (props: PaginationProps) => {
  const { currentPage = 1, totalPages = 1, updateCurrentPage } = props;
  const [currentPageState, setCurrentPageState] = useState(currentPage);
  const nextPageEnabled = currentPageState < totalPages;
  const previousPageEnabled = currentPageState > 1;

  useEffect(() => {
    setCurrentPageState(currentPage);
  }, [currentPage]);

  const nextPage = () => {
    if (updateCurrentPage) {
      updateCurrentPage(currentPageState + 1);
    } else {
      setCurrentPageState(currentPageState + 1);
    }
  }

  const previousPage = () => {
    if (updateCurrentPage) {
      updateCurrentPage(currentPageState - 1);
    } else {
      setCurrentPageState(currentPageState - 1);
    }
  }

  const onPageChanged = (page: number) => {
    if (updateCurrentPage) {
      updateCurrentPage(page);
    } else {
      setCurrentPageState(page);
    }
  }

  return {
    currentPage: currentPageState,
    updateCurrentPage: onPageChanged,
    nextPage,
    previousPage,
    totalPages: totalPages || 1,
    nextPageEnabled,
    previousPageEnabled,
  }
};

export default usePresenter;